export default "__VITE_ASSET__DK8Yh5Qp__"